import script from "./UploadCompanyDocumentDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadCompanyDocumentDialog.vue?vue&type=script&setup=true&lang=js"

import "./UploadCompanyDocumentDialog.vue?vue&type=style&index=0&id=97be2ba2&scoped=true&lang=css"

import exportComponent from "/var/www/proinad/erpz_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97be2ba2"]])

export default __exports__